import logo from './logo.svg';
import './App.css';
import LTSMigration from './Components/MainComponents/LTSMigration';
import SPItems from './Components/MainComponents/SPItems';
import SPItemTypes from './Components/MainComponents/SPItemTypes';
import Sessions from './Components/MainComponents/Sessions';
import SPItemView from './Components/MainComponents/SPItemView';
import SPItemAdd from './Components/MainComponents/SPItemAdd';
import ActivityCategories from './Components/MainComponents/ActivityCategories';
import ActivityLogs from './Components/MainComponents/ActivityLogs';
import Nyi from './Components/MainComponents/NYI';
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Components/Styles/react/rwindow.css';
import './Components/Styles/react/mdatatable.css';
import './Components/Styles/react/rmodal.css';
import './Components/Styles/all-main.css';
import './Components/Styles/react/r-multi-tab.css';
import './Components/Styles/react/rdatepicker.css';
import './plugins/fontawesome6/css/all.min.css';
import './styles/root.css';
import React, { useState } from 'react';
import {
    createBrowserRouter,
    RouterProvider,
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
    Navigate,
    Outlet
} from "react-router-dom";
import Root from './routes/root';
import ErrorPage from "./routes/errors/notFound";
import Committees from './Components/MainComponents/Committees';
import Categories from './Components/MainComponents/Categories';
import TrackingStatus from './Components/MainComponents/TrackingStatus';
import Officials from './Components/MainComponents/Officials';
import OfficialTypes from './Components/MainComponents/OfficialTypes';
import CouncilTypes from './Components/MainComponents/CouncilStatus';
import CommitteeTypes from './Components/MainComponents/CommitteeTypes';
import Councils from './Components/MainComponents/Councils';
import CouncilOfficials from './Components/MainComponents/CouncilOfficials';
import CouncilCommittees from './Components/MainComponents/CouncilCommittees';
import AccountsManager from './Components/MainComponents/AccountsManager';
import RolesManager from './Components/MainComponents/RolesManager';
import Dashboard from './Components/MainComponents/Dashboard';
import Legislations from './Components/MainComponents/Legislations';
import Reports from './Components/MainComponents/Reports';
import FtpLocations from './Components/MainComponents/FtpLocations';
import FilesRelink from './Components/MainComponents/FilesRelink';

export async function itemLoader({ params }) {
    const Id = params.Id;
    return { Id };
}

const App = _ => {
    const [refreshTable, setRefreshTable] = useState(-999);
    const [globalVars, setGlobalVars] = useState({ rootClass: "" });

    const setRootClass = c => {
        if (globalVars.rootClass != c) {
            console.log(`${c} == ${globalVars.rootClass}`);
            setGlobalVars(g => ({ ...g, rootClass: c }))
        }
    };

    const api_regex = /^\/api\/.*/
    const plugins_regex = /^\/plugins\/.*/
    // if using "/api/" in the pathname, don't use React Router
    if (api_regex.test(window.location.pathname) || plugins_regex.test(window.location.pathname)) {
        return <div /> // must return at least an empty div
    } else {
        return (<div id="root" className={globalVars.rootClass}>
            <React.StrictMode>
                <RouterProvider router={createBrowserRouter(
                    [
                        //default routes
                        {
                            path: "/",
                            element: <Navigate to="/dashboard" replace />,
                            index: true
                        },
                        {
                            path: "item-properties",
                            element: <Navigate to="/item-properties/types" />
                        },



                        {
                            path: "/",
                            element: <Root
                                context={[refreshTable, setRefreshTable, setRootClass]}
                                refreshTable={_ => setRefreshTable(i => i + 1)}
                                setRootClass={setRootClass}
                            />,
                            errorElement: <ErrorPage />,
                            handle: {
                                crumb: () => {
                                    return {
                                        link: <Link to="/">Home</Link>,
                                        name: "Home"
                                    }
                                }
                            },
                            children: [
                                {
                                    path: "dashboard",
                                    element: <Dashboard />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Dashboard</Link>,
                                                name: "Dashboard"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "documents",
                                    element: <Nyi />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Documents</Link>,
                                                name: "Documents"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "agenda",
                                    element: <Nyi />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Agenda</Link>,
                                                name: "Agenda"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "legislations",
                                    element: <Legislations />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Legislations</Link>,
                                                name: "Legislations"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "communications",
                                    element: <Nyi />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Communications</Link>,
                                                name: "Communications"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "reports",
                                    element: <Reports />,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="#">Reports</Link>,
                                                name: "Reports"
                                            }
                                        },
                                    }
                                },
                                {
                                    path: "item-properties",
                                    element: <Outlet context={[refreshTable, setRefreshTable, setRootClass]} />,
                                    children: [
                                        {
                                            path: "types",
                                            element: <SPItemTypes />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">SP Item Types</Link>,
                                                        name: "SP Item Types"
                                                    }
                                                },
                                            },
                                            index: true
                                        },
                                        {
                                            path: "sessions",
                                            element: <Sessions />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">SP Sessions</Link>,
                                                        name: "SP Sessions"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "committees",
                                            element: <Committees />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">SP Committees</Link>,
                                                        name: "SP Committees"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "categories",
                                            element: <Categories />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">SP Categories</Link>,
                                                        name: "SP Categories"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "status",
                                            element: <TrackingStatus />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Tracking Status</Link>,
                                                        name: "Tracking Status"
                                                    }
                                                },
                                            },
                                            index: true
                                        }
                                    ]
                                },
                                {
                                    path: "officials",
                                    element: <Outlet context={[refreshTable, setRefreshTable, setRootClass]} />,
                                    children: [
                                        {
                                            path: "list",
                                            element: <Officials />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Officials</Link>,
                                                        name: "Officials"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "types",
                                            element: <OfficialTypes />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Official Types</Link>,
                                                        name: "Official Types"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "council-statuses",
                                            element: <CouncilTypes />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Council Status</Link>,
                                                        name: "Council Status"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "committee-types",
                                            element: <CommitteeTypes />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Official Committee Types</Link>,
                                                        name: "Official Committee Types"
                                                    }
                                                },
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: "councils",
                                    element: <Outlet context={[refreshTable, setRefreshTable, setRootClass]} />,
                                    children: [
                                        {
                                            path: "list",
                                            element: <Councils />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Councils</Link>,
                                                        name: "Councils"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "officials",
                                            element: <CouncilOfficials />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Council Members</Link>,
                                                        name: "Council Members"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "committees",
                                            element: <CouncilCommittees />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Council Committees</Link>,
                                                        name: "Council Committees"
                                                    }
                                                },
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: "sp-items",
                                    element:
                                        <SPItems />
                                    ,
                                    handle: {
                                        crumb: () => {
                                            return {
                                                link: <Link to="/sp-items">SP Items</Link>,
                                                name: "View SP Item"
                                            }
                                        }
                                    },
                                    children: [
                                        {
                                            path: "view/:Id",
                                            element: <SPItemView setRootClass={setRootClass} />,
                                            loader: itemLoader,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">View Item</Link>,
                                                        name: "View SP Item"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "edit/:Id",
                                            element: <SPItemAdd editMode={true} />,
                                            loader: itemLoader,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Edit Item</Link>,
                                                        name: "Edit SP Item"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "create",
                                            element: <SPItemAdd />,
                                            loader: _ => { return {}; },
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Create New Item</Link>,
                                                        name: "Create New SP Item"
                                                    }
                                                },
                                            }
                                        },
                                    ]
                                },
                                {
                                    path: "admin-panel",
                                    element: <Outlet context={[refreshTable, setRefreshTable, setRootClass]} />,
                                    children: [
                                        {
                                            path: "users",
                                            element: <AccountsManager />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">User Accounts</Link>,
                                                        name: "User Accounts"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "roles",
                                            element: <RolesManager />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">User Roles</Link>,
                                                        name: "User Roles"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "activities",
                                            element: <ActivityCategories />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Role Activities</Link>,
                                                        name: "Role Activities"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "logs",
                                            element: <ActivityLogs />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Activity Logs</Link>,
                                                        name: "Activity Logs"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "ftp-locations",
                                            element: <FtpLocations />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">FTP Locations</Link>,
                                                        name: "FTP Locations"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "db-sync",
                                            element: <LTSMigration />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">DB Sync</Link>,
                                                        name: "DB Sync"
                                                    }
                                                },
                                            }
                                        },
                                        {
                                            path: "files-relink",
                                            element: <FilesRelink />,
                                            handle: {
                                                crumb: () => {
                                                    return {
                                                        link: <Link to="#">Files Relink</Link>,
                                                        name: "Files Relink"
                                                    }
                                                },
                                            }
                                        },
                                    ]
                                },

                            ]
                        },
                    ]
                    , {
                        basename: "/CGPP-LTS",
                    })
                } />
            </React.StrictMode>
        </div>);
    }
}

export default App;
